import React, { useRef, useEffect, useState } from 'react';
import PrintPdf from './PrintPdf';
import { generatePdfFromElement } from '../utils/generatePdf';

const PrintForm = () => {
    const printRef = useRef(null);
    const [pdfUrl, setPdfUrl] = useState(null);

    useEffect(() => {
        const sID = localStorage.getItem('sID');
        if (!sID || sID === 'null') {
            window.location.href = '/';
        }
    }, []);

    const generatePdf = async () => {
        const pdf = await generatePdfFromElement(printRef.current);
        const blob = pdf.output('blob');
        const url = URL.createObjectURL(blob);
        setPdfUrl(url);
    };

    return (
        <div style={{ padding: '20px', marginTop: '100px' }}>
            <div style={{ display: 'flex', gap: '15px', marginBottom: '15px' }}>
                <button className="btn btn-danger" onClick={generatePdf}>
                    📄 Generate PDF
                </button>

                {pdfUrl && (
                    <a
                        href={pdfUrl}
                        download={`Application_${localStorage.getItem('sID')}.pdf`}
                        className="btn btn-success"
                    >
                        ⬇️ Download PDF
                    </a>
                )}
            </div>

            {/* Hidden render target */}
            <div style={{ position: 'absolute', left: '-9999px', top: 0 }}>
                <div ref={printRef}>
                    <PrintPdf />
                </div>
            </div>

            {/* PDF VIEWER */}
            {pdfUrl && (
                <iframe
                    src={pdfUrl}
                    title="PDF Preview"
                    style={{
                        width: '100%',
                        height: '90vh',
                        border: '1px solid #ccc'
                    }}
                />
            )}
        </div>
    );
};

export default PrintForm;
